import React from "react";
import "./main.sass";
export const MainLayout: React.FC = ({ children }) => {
	return <div className="container is-fluid">{children}</div>;
};
